import { stringOneOf } from "./oneOf";

const booleanFieldFilterOptions = ["true", "false", "any"] as const;
export type BooleanFieldFilterOption = (typeof booleanFieldFilterOptions)[number];

export const booleanFieldFilter = stringOneOf(...booleanFieldFilterOptions);
